import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import AlertCoordinator from './components/alerts/AlertCoordinator.tsx';
import ErrorBoundary from './components/errorBoundary/ErrorBoundary.tsx';
import IsOnlineCoordinator from './components/isOnline/IsOnlineCoordinator.tsx';
import LoadingModalCoordinator from './components/modal/LoadingModalCoordinator.tsx';
import AppInitializer from './AppInitializer.tsx';
import AllRoutes from './Routes';
import { themeOptions } from './theme/theme.tsx';
import { isStaleAssetError, recoverFromStaleAssets } from './common/staleAssetRecovery';

window.addEventListener('error', (event) => {
  if (isStaleAssetError(event.error ?? event.message)) {
    void recoverFromStaleAssets();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (isStaleAssetError(event.reason)) {
    void recoverFromStaleAssets();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider theme={themeOptions}>
          <CssBaseline />
          <AppInitializer>
            <AllRoutes />
          </AppInitializer>
          <IsOnlineCoordinator />
          <LoadingModalCoordinator />
          <AlertCoordinator />
        </ThemeProvider>
      </LocalizationProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
